module.exports = __webpack_public_path__ + "img/id-wrong-background.8539b98f.png";